import { initialState } from "../../../LiveSwitch/liveSwitchReducer";
import { ApplicationData, ClientPhase } from "../../types";
import { apiCallsInitialState } from "../../../Shared/Redux/Reducers/apiStatusReducer";

export default {
    localizations: null as any,
    currentPhase: ClientPhase.Welcome,
    order: null as any,
    chats: [],
    photos: [],
    accessInfo: null as any,
    registrations: [],
    photoRequests: [],
    numberInQueue: null,
    estimatedStart: null,
    mentor: null,
    currentPosition: null,
    liveSwitchToken: null,
    deviceId: null as any,

    fullscreen: false,
    invalidCode: false,
    haveNetworkAccess: true,
    permissions: {
        haveCameraAccess: "prompt",
        haveLocationAccess: "prompt",
    },
    apiCallsInProgress: apiCallsInitialState,
    liveSwitchState: initialState,
    notifications: [],
    canLeave: false,
    scheduleSlots: null,
    activeObservers: null as any,
    activeMentee: false,
    recordingState: true,
    onPremiseSettings: null as any,
    connectionQuality: null as any,
    externalObservers: []
} as ApplicationData;
